"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIC = exports.LINKEDIN_URL = exports.LINKEDIN_USERNAME = exports.EMAIL_ADDRESS = exports.NUMBERS = exports.LETTERS = void 0;
exports.LETTERS = /^[A-Z\s]+$/i;
exports.NUMBERS = /^[0-9]+$/;
exports.EMAIL_ADDRESS = /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
exports.LINKEDIN_USERNAME = /^[_A-z0-9]*((-|)*[_A-z0-9])*$/;
exports.LINKEDIN_URL = /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/;
exports.BIC = /^[A-Z]{6}(([A-Z0-9]{2})|([A-Z0-9]{5}))$/;
